export const RANGE_TRACK_COLOR = '#DEE2E6'
type RangeBackgroundGenerator = (percent: number) => string

export const primaryColorGeneratorFactory =
	(color: string): RangeBackgroundGenerator =>
	percent =>
		`linear-gradient(to right, ${color} 0%, ${color} ${percent}%, ${RANGE_TRACK_COLOR} ${percent}%, ${RANGE_TRACK_COLOR} 100%)`
